/* Fixlr platform identity: icon mark + dark/light wordmarks. Tenant white-labelling lives in PortalBrand / tenant branding;
   this component is only ever the *platform* brand (sidebar for staff, login chrome, "Powered by Fixlr"). */
const ICON = "/fixlr-icon.png";
const WORD_DARK = "/fixlr-logo-dark.png";   // dark text — for light backgrounds
const WORD_LIGHT = "/fixlr-logo-light.png"; // light text — for dark backgrounds
const NAME = "Fixlr";

function Wordmark({ h = "h-8", onDark = false, testid = "sidebar-logo" }) {
  if (onDark) return <img src={WORD_LIGHT} alt={NAME} className={`${h} w-auto`} data-testid={testid} />;
  return (
    <>
      <img src={WORD_DARK} alt={NAME} className={`${h} w-auto dark:hidden`} data-testid={testid} />
      <img src={WORD_LIGHT} alt={NAME} className={`${h} w-auto hidden dark:block`} data-testid={`${testid}-dark`} />
    </>
  );
}

export default function PlatformBrand({ variant = "sidebar", className = "" }) {
  if (variant === "icon") {
    return <img src={ICON} alt={NAME} className={`h-8 w-8 object-contain ${className}`} data-testid="sidebar-logo-icon" />;
  }
  if (variant === "mobile") {
    return (
      <span className={`flex items-center gap-1.5 min-w-0 ${className}`} data-testid="mobile-brand">
        <Wordmark h="h-7" testid="mobile-brand-logo" />
      </span>
    );
  }
  if (variant === "login-hero") {
    return (
      <div className={`flex items-center gap-4 ${className}`} data-testid="login-brand-hero">
        <Wordmark h="h-14 lg:h-16" onDark testid="login-brand-hero-logo" />
      </div>
    );
  }
  if (variant === "login-right") {
    return (
      <span className={`flex items-center gap-2.5 min-w-0 ${className}`} data-testid="login-brand-right">
        <Wordmark h="h-12" testid="login-brand-logo" />
      </span>
    );
  }
  if (variant === "powered") {
    return (
      <span className={`inline-flex items-center gap-1.5 ${className}`} data-testid="powered-by-brand">
        <img src={ICON} alt={NAME} className="h-4 w-4 object-contain" />
        <span className="font-semibold">{NAME}</span>
      </span>
    );
  }
  return (
    <span className={`flex items-center justify-center gap-2.5 min-w-0 ${className}`} data-testid="sidebar-brand">
      <Wordmark h="h-14" testid="sidebar-logo" />
    </span>
  );
}
